import useSendbirdStateContext from "@sendbird/uikit-react/useSendbirdStateContext";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams,useNavigate, Link } from 'react-router-dom'
import { getPatientDetails } from '../redux/actions/passActions'
import DocumentRequest from './payment/DocumentRequest'
import PayRequest from './payment/PayRequest'
import AddPaymentRequest from './payment/PayRequestForm'
import AddDocumentRequest from './payment/RequestDocumentForm'
import PrevChatPage from './shared/chat/prev/prevchatPage'
import Modal from './shared/modal'
import { Icon } from '@iconify/react'
import { toastError } from "../utils/helpers/methods";
import { Badge } from "flowbite-react";
import { unToogleFilter } from "../redux/slices/chat";
import { locationUIInfo } from "./shared/CityCode";
import { togglePatientDetail } from "../redux/slices/filter";

const PatientDetail = () => {
  const { patientId } = useParams()
  const dispatch = useDispatch()
  const { Patientinfo } = useSelector((state) => state.pass)
  const { userToken } = useSelector((state) => state.auth)
  const [openModal, setOpenModal] = useState(false)
  const [dependantId, setDependentId] = useState('')
  const [depenentModal, setDependentModal] = useState(false)
  const [isViewDependent, setIsViewDependent] = useState(false)
  const [generalId, setGeneralId] = useState('')
  const store = useSendbirdStateContext()
  var sdk = store?.stores.sdkStore.sdk
  const navigate=useNavigate()

  useEffect(() => {
    if (patientId) {
      setGeneralId(patientId)
    }
    if (dependantId) {
      setGeneralId(dependantId)
    }
  }, [patientId, dependantId])

  useEffect(() => {
    //   dispatch(getListPasswords({ token: userToken }));
    dispatch(getPatientDetails({ token: userToken, patientId: generalId }))
    //eslint-disable-next-line
  }, [generalId])
  const handleReverse = (data) => {
    const rev = [...data].reverse()
    return rev
  }
  const [activeTab, setActiveTab] = useState(1)

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex)
  }
  const handleRadioChange = (event) => {
    setDependentId(event.target.value)
    setDependentModal(false)
    handleTabClick(1)
  }

 const gotoChat=async(patientinfo)=>{
    var user = patientinfo.patient_login.sendbird_user_id != undefined && patientinfo.patient_login.sendbird_user_id != null
    if(user!=undefined){ 
      dispatch(unToogleFilter())
      navigate('/chat',{ state: patientinfo })
    } else{
      toastError("Not able to chat at this moment.")
    }
    }
    const viewDetail = () => {
      dispatch(togglePatientDetail(true))
    }
  return (
    <div className='container mx-auto py-8'>
      <div className='w-full flex md:flex-row flex-col justify-between mb-4'>
        <div className="flex items-center cursor-pointer" 
          onClick={() => navigate('/patientList')}
        >
        <Icon
          icon={'ep:back'}
          fontSize={18}
          className='text-everglade-800 cursor-pointer'
        />
          <h1 className='text-lg ml-0 font-bold text-everglade-800 ps-2'>
            Back
          </h1>
        </div>
        <div className='flex flex-row gap-5 items-center'>
          {/* <button className='w-[100px] h-[35px] bg-indigo-500 rounded-full flex flex-row justify-center items-center gap-2'>
                    <Icon icon='ic:round-plus' color='#ffbe0b' fontSize={18} />
                    <p className='text-white'>New</p>
                </button>
                <div className='relative'>
                    <input className='w-[80%] h-[40px] rounded-xl border-[1px] border-[#c4c4c4] focus:border-indigo-500 pl-[40px]' placeholder='Search' />
                    <Icon icon='ic:sharp-search' color='#4361ee' fontSize={24} className='absolute top-2 left-2' />
                </div> */}
        </div>
      </div>
      <div className='flex flex-col items-center mb-4'>
        <h2 className='text-[25px] ml-0 font-bold text-everglade-800 mb-2'>
          Patient Details
        </h2>
        <div className='flex flex-col items-center flex-wrap'>
        <div  className="flex flex-wrap">
          <h3 className='uppercase text-[22px] mr-0 font-bold text-everglade-800'>
            {Patientinfo?.first_name} {Patientinfo?.last_name}
          </h3>
        </div>
        <div className='flex flex-row items-center justify-between ps-4'>
          {locationUIInfo(Patientinfo)}
          {Patientinfo?.patients?.is_vip == 1 && <Icon icon="quill:vip" fontSize={40} color='#ffbf00'></Icon>}
          {/* {Patientinfo?.patients?.is_vip==1 &&  <Badge className="ml-1" color="warning">VIP</Badge>} */}
          {Patientinfo?.patients && <Badge className="ml-1" size={40} color={(Patientinfo?.patients.deleted_at == null || Patientinfo?.patients.deleted_at == '') ? 'success' : 'failure'}>{(Patientinfo?.patients.deleted_at == null || Patientinfo?.patients.deleted_at == '') ? 'Active' : 'InActive'}</Badge>}
          {Patientinfo?.employee_details?.location_group?.group_name && <Badge className="ml-1" color="blue" size={40}>{Patientinfo?.employee_details?.location_group?.group_name}</Badge>}
        </div>
        </div>
      </div>
      <div className='w-full mx-auto'>
        <div className=''>
          <div className='container md:mx-auto flex items-center justify-between px-4 py-2'>
            <div className='flex md:flex-row flex-col w-full'>
              <div className='flex border-b border-gray-300 w-full overflow-x-auto '>
                <div
                  className={`flex-1 flex-shrink-0 text-[14px] whitespace-nowrap md:text-base lg:whitespace-normal text-center px-4 py-2  w-full uppercase cursor-pointer font-medium ${
                    activeTab === 1
                      ? 'border-b-2 border-everglade-500 text-everglade-500'
                      : 'text-everglade-900'
                  }`}
                  onClick={() => handleTabClick(1)}
                >
                  Personal Information
                </div>
                <div
                  className={`flex-1 flex-shrink-0 text-[14px] whitespace-nowrap md:text-base lg:whitespace-normal text-center px-4 py-2 uppercase cursor-pointer font-medium ${
                    activeTab === 2
                      ? 'border-b-2 border-everglade-500 text-everglade-500'
                      : 'text-everglade-900'
                  }`}
                  onClick={() => handleTabClick(2)}
                >
                  Employer Info
                </div>
                <div
                  className={`flex-1 flex-shrink-0 text-[14px] whitespace-nowrap md:text-base lg:whitespace-normal text-center px-4 py-2 uppercase cursor-pointer font-medium ${
                    activeTab === 3
                      ? 'border-b-2 border-everglade-500 text-everglade-500'
                      : 'text-everglade-900'
                  }`}
                  onClick={() => handleTabClick(3)}
                >
                  Insurance Information
                </div>
                {Patientinfo?.patient_entry != null && (
                  <div
                    className={`flex-1 flex-shrink-0 text-[14px] whitespace-nowrap md:text-base lg:whitespace-normal text-center px-4 py-2 uppercase cursor-pointer font-medium ${
                      activeTab === 4
                        ? 'border-b-2 border-everglade-500 text-everglade-500'
                        : 'text-everglade-900'
                    }`}
                    onClick={() => handleTabClick(4)}
                  >
                    Payment Request
                  </div>
                )}
                {Patientinfo?.patient_entry != null && (
                  <div
                    className={`flex-1 flex-shrink-0 text-[14px] whitespace-nowrap md:text-base lg:whitespace-normal text-center px-4 py-2 uppercase cursor-pointer font-medium ${
                      activeTab === 5
                        ? 'border-b-2 border-everglade-500 text-everglade-500'
                        : 'text-everglade-900'
                    }`}
                    onClick={() => handleTabClick(5)}
                  >
                    Request Document
                  </div>
                )}
                {Patientinfo?.patient_sbholds.length > 0 && (
                  <div
                    className={`flex-1 flex-shrink-0 text-[14px] whitespace-nowrap md:text-base lg:whitespace-normal text-center px-4 py-2 uppercase cursor-pointer font-medium ${
                      activeTab === 6
                        ? 'border-b-2 border-everglade-500 text-everglade-800'
                        : 'text-everglade-900'
                    }`}
                    onClick={() => handleTabClick(6)}
                  >
                    Previous Provider chats
                  </div>
                )}
              </div>
            </div>
          </div>
          {activeTab === 1 && (
            <div className='mt-4 flex justify-end'>
              <div className='flex  flex-row items-center gap-5'>
                {
                Patientinfo?.patient_login !== null && 
                Patientinfo?.patient_login.sendbird_user_id!=null && 
                Patientinfo?.patient_login.sendbird_user_id!="" &&
                Patientinfo?.patient_entry!=null &&
                Patientinfo?.patients.practice!=null&&
                Patientinfo?.patients.practice.def_provider_id!=null &&
                 (
                  <Icon
                    icon={'humbleicons:chat'}
                    fontSize={30}
                    className='text-everglade-500 cursor-pointer'
                    onClick={()=> gotoChat(Patientinfo)}
                  />
                )}

                <span
                  onClick={() => { setIsViewDependent(false); setDependentModal(true) }}
                  className={` ${Patientinfo?.patient_login?.dependant_ids?.length > 1 &&
                    'mr-5 p-2 bg-everglade-600 text-white rounded-md'
                    }`}
                >
                  {Patientinfo?.patient_login?.dependant_ids?.length > 1 && (
                    <span
                      
                      className=' hover:cursor-pointer'
                    >
                      {' '}
                      Switch dependent{' '}
                    </span>
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
        {Patientinfo && (
          <div className='mt-0'>
            {activeTab === 1 && (
              <div className='px-4 py-5 sm:p-6'>
                {/* <h3 className="text-lg leading-6 font-medium text-gray-900">
              Tab 1 Content
            </h3> */}
                <div className='mt-2 max-w  '>
                  <div className='bg-white rounded-lg shadow-gray-800/40 shadow p-6 flex '>
                    {/* <h2 className="text-xl font-bold mb-4">Personal Information</h2> */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 w-full">
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Name:
                        </span>
                        <span  className='flex flex-row items-center uppercase text-base break-words'>
                          {Patientinfo?.first_name} {Patientinfo?.last_name} 
                          {Patientinfo?.patients?.is_vip==1 && <Icon className="ml-2" icon="quill:vip" fontSize={24} color='#ffbf00'></Icon>}
                        </span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold text-lg text-everglade-800'>
                          Email Address:
                        </span>
                        <span className="text-base break-all">{Patientinfo?.email_address}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold text-lg text-everglade-800'>
                          Date of Birth:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.dob}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Relationship:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.relationship}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Gender:
                        </span>
                        <span className="text-base break-words">
                          {Patientinfo?.gender == 'F' ? 'Female' : 'Male'}
                        </span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        {Patientinfo?.employer_tag.map((a) => (
                          <button
                            key={a.id}
                            className='text-white font-bold py-2 my-2 mx-2 px-2 rounded'
                            style={{ backgroundColor: a.colour_code }}
                          >
                            {a.tag_name}
                          </button>
                        ))}
                        {Patientinfo?.patient_tags.map((a) => (
                          <button
                            key={a.id}
                            className='text-white font-bold py-2 my-2 mx-2 px-2 rounded'
                            style={{ backgroundColor: a.colour_code }}
                          >
                            {a.tag_name}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 2 && (
              <div className='px-4 py-5 sm:p-6 '>
                <div className='mt-2 max-w text-sm  h-full'>
                  <div className='bg-white rounded-lg shadow-gray-800/40 shadow p-6 flex '>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 w-full">
                      {/* <h2 className="text-xl font-bold mb-4">Employer Info</h2> */}
                      {Patientinfo?.relationship == 'Employee' ||
                      Patientinfo?.relationship == 'Self' && (
                        <div className="w-full">
                          <div className='flex flex-col items-start w-full'>
                            <span className='font-bold mb-1 text-lg text-everglade-800'>
                              Current Employer :
                            </span>
                            <span className="text-base break-words">
                              {
                                Patientinfo?.employee_details?.location_group?.group_name
                              }
                            </span>
                          </div>
                        </div>
                      ) }
                      {Patientinfo?.relationship != 'Self' && (
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                        Dependent of (Employee):
                        </span>
                        <span className="text-base break-all uppercase">
                          {Patientinfo?.employee_details?.address?.first_name +' '+Patientinfo?.employee_details?.address?.last_name}
                        </span>
                      </div>)}
                      {Patientinfo?.relationship != 'Self' && (
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                        Employer:
                        </span>
                        <span className="text-base break-all">
                          { Patientinfo?.employee_details?.location_group.group_name||'-'}
                        </span>
                      </div>)}
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Subscriber ID:
                        </span>
                        <span className="text-base break-all">
                          {Patientinfo?.employee_details?.subscriber_id||'-'}
                        </span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Group:
                        </span>
                        <span className="text-base break-words">
                          S1{Patientinfo?.employee_details?.location_group?.groups}
                        </span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Status:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.patient_status}</span>
                      </div>
                      {Patientinfo?.relationship === 'Self'&& Patientinfo?.patient_login?.dependant_ids?.length > 1 && 
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Dependents:
                        </span>
                        <span
                          onClick={() => { setIsViewDependent(true); setDependentModal(true) }}
                          className={` ${Patientinfo?.patient_login?.dependant_ids?.length > 1 &&
                            'mr-5 p-2 bg-everglade-600 text-white rounded-md'
                            }`}
                        >
                            <span
                              className=' hover:cursor-pointer'>
                              View dependent
                            </span>
                          
                        </span>
                      </div>}
                    </div>              
                  </div>
                </div>
              </div>
            )}
            {activeTab === 3 && (
              <div className='px-4 py-5 sm:p-6'>
                <div className='mt-2 max-w text-sm  h-full'>
                  <div className='bg-white rounded-lg shadow-gray-800/40 shadow p-6 flex'>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 w-full">
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Carrier Name:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data?.carrier_name}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Coverage From:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data?.coverage_from}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Coverage Thru:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data?.coverage_thru} </span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Coverage:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance.coverage}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Plan Name:
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data?.plan_type}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Member Id:
                        </span>
                        <span className="text-base break-all">{Patientinfo?.insurance_data?.member_id}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Tier :
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data.tier}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Tpa Name :
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data?.tpa_name}</span>
                      </div>
                      <div className='flex flex-col items-start w-full'>
                        <span className='font-bold mb-1 text-lg text-everglade-800'>
                          Sub Group :
                        </span>
                        <span className="text-base break-words">{Patientinfo?.insurance_data?.sub_group}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 4 && (
              <>
                {openModal && (
                  <Modal title={"Add Payment Request"}
                    className='w-full lg:w-1/2 shadow-2xl'
                    close={() => setOpenModal(false)}
                  >
                    <AddPaymentRequest
                      patientId={Patientinfo && Patientinfo?.patient_id}
                      close={() => setOpenModal(false)}
                    />
                  </Modal>
                )}
                <div className='px-4 py-5 sm:p-6'>
                  <div className=' max-w text-sm  h-full'>
                    <div className='rounded-lg shadow-gray-800/20  p-6 min-h-[600px] overflow-auto'>
                      {Patientinfo && (
                        <PayRequest
                          setOpenModal={() => setOpenModal(true)}
                          data={handleReverse(Patientinfo?.careapp_payreq)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {activeTab === 5 && (
              <>
                {openModal && (
                  <Modal
                    title={"Add Request Document"}
                    className='w-full lg:w-1/2 shadow-2xl'
                    close={() => setOpenModal(false)}
                  >
                    <AddDocumentRequest
                      patientId={Patientinfo && Patientinfo?.patient_id}
                      close={() => setOpenModal(false)}
                    />
                  </Modal>
                )}
                <div className='px-4 py-5 sm:p-6'>
                  <div className='mt-2 max-w text-sm  h-full'>
                    <div className='rounded-lg shadow-gray-800/20  overflow-auto'>
                      {Patientinfo && (
                        <DocumentRequest
                          setOpenModal={() => setOpenModal(true)}
                          data={handleReverse(
                            Patientinfo?.careapp_document_req
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            {activeTab === 6 && (
              <>
                <PrevChatPage data={Patientinfo?.patient_sbholds} />
              </>
            )}
            {depenentModal && (
              <Modal
              title={isViewDependent?"View Dependent":"Switch To Dependent"}
              className='w-[500px] shadow-2xl'
              close={() => setDependentModal(false)}
            >
              <div className='w-full mb-10 '>
                <div className="w-full col-span-3">
                  <div className="w-full bg-white p-4 overflow-x-auto">
                    <table className="w-full text-sm text-left text-gray-700 border-collapse">
                      <thead className="border-b border-gray-100 bg-gray-50">
                        <tr>
                          <th className="px-4 py-2 font-semibold text-everglade-800 bg-everglade-300">
                            Dependent Name
                          </th>
                          <th className="px-4 py-2 font-semibold text-everglade-800 bg-everglade-300">
                            Relationship
                          </th>
                          {!isViewDependent && (
                            <th className="px-4 py-2 font-semibold text-everglade-800 bg-everglade-300 text-center">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {Patientinfo?.patient_login?.dependant_ids.map((e, index) => (
                          <tr
                            key={e.id || index}
                            className="border-b last:border-0 hover:bg-gray-50 transition"
                          >
                            <td className="px-4 py-2 uppercase">
                              {e?.address.first_name + ' ' + e.address.last_name}
                            </td>

                            <td className="px-4 py-2 capitalize">
                              {e?.address.relationship}
                            </td>

                            {!isViewDependent && (
                              <td className="px-4 py-2 text-center">
                                {e.id === Patientinfo?.patient_id ? (
                                  <span className="text-gray-600 bg-gray-200 font-medium rounded-md text-sm px-4 py-2 inline-block">
                                    Switch
                                  </span>
                                ) : (
                                  <Link
                                    to={`/patientDetails/${e.id}`}
                                    className="text-white bg-everglade-700 hover:bg-everglade-800 focus:ring-2 focus:ring-everglade-300 font-medium rounded-md text-sm px-4 py-2 inline-block"
                                    onClick={viewDetail}
                                  >
                                    Switch
                                  </Link>
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Modal>

            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default PatientDetail
